import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import ResumeBox from "@/common/components/ResumeBox";
import { useNavigate, useParams } from "react-router-dom";
import useMaintenanceObjectiveAction from "../../hooks/useMaintenanceObjectiveAction";
import { ChevronsRightIcon } from "lucide-react";

const MaintenanceObjectiveActionsShow = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const {
    data: objectiveAction,
    isPending: isObjectiveActionPending,
    refetch: refetchObjectiveAction,
    error: objectiveActionError = {} as any,
  } = useMaintenanceObjectiveAction(id);

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-64px)]"
      statusCode={objectiveActionError?.status}
      refetchFunction={refetchObjectiveAction}
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{ fallback: `/objective-maintenance/actions` }}
          titleClassName="text-nowrap max-w-56 overflow-hidden text-ellipsis font-normal text-base"
          title="Objetos de manutenção"
          subtitle={(
            <div className="flex items-center gap-2">
              <h2 className="text-white-400">
                Ação
              </h2>

              <ChevronsRightIcon className="text-white-400" />

              <h2 className="text-white-800">
                {objectiveAction?.display_name}
              </h2>
            </div>
          )}
          isLoading={isObjectiveActionPending}
          buttons={(
            <div className="flex items-center gap-3">
              <Button
                name="update"
                operationKlassToCheckPermission="Admin::Maintenance::ObjectiveActions::Update"
                onClick={() => navigate('edit')}
              >
                Editar
              </Button>
            </div>
          )}
        />

        <Box className="max-h-[calc(100vh-132px)] overflow-y-auto flex flex-col gap-4">
          <p className="text-lg font-medium">
            Dados gerais da ação
          </p>

          <ResumeBox
            label="Nome da ação"
            value={objectiveAction?.display_name}
            isLoading={isObjectiveActionPending}
            testId="display_name"
          />

          <ResumeBox
            label="Descrição"
            value={objectiveAction?.description}
            isLoading={isObjectiveActionPending}
            testId="description"
          />
        </Box>
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceObjectiveActionsShow;
